import { Link } from "react-router-dom";
import { SITE } from "../lib/site";
import { Zap, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy text-white border-t border-navy-800"
    >
      <div className="container-pro py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex h-10 w-10 items-center justify-center bg-white text-navy">
              <Zap className="h-4 w-4" strokeWidth={2.5} />
            </span>
            <div className="leading-tight">
              <div className="font-heading font-black tracking-tight text-base">
                FIBER DRAFT
              </div>
              <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-slateblue-400">
                NYCT/MTA Electrical Engineering · Est. 2016
              </div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed max-w-md">
            A specialty electrical engineering firm supporting NYCT MTA transit
            infrastructure — drafting, as-built documentation, and FAT/SAT
            commissioning packages built to MTA specification.
          </p>
          <p className="mt-6 text-[11px] font-mono uppercase tracking-[0.2em] text-slateblue-400">
            {SITE.registry}
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="overline text-slateblue-400 mb-4">Navigate</div>
          <ul className="space-y-2 font-heading text-sm">
            <li>
              <Link
                to="/"
                data-testid="footer-link-home"
                className="hover:text-slateblue-400 transition-colors"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                data-testid="footer-link-services"
                className="hover:text-slateblue-400 transition-colors"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/portfolio"
                data-testid="footer-link-portfolio"
                className="hover:text-slateblue-400 transition-colors"
              >
                Portfolio
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                data-testid="footer-link-contact"
                className="hover:text-slateblue-400 transition-colors"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="overline text-slateblue-400 mb-4">Field Office</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-slateblue-400 shrink-0" />
              <span>{SITE.address}</span>
            </li>
            <li className="flex gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-slateblue-400 shrink-0" />
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="hover:text-white"
              >
                {SITE.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-pro py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-white/50">
            © {new Date().getFullYear()} Fiber Draft. All rights reserved.
          </p>
          <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-white/50">
            Not affiliated with the Metropolitan Transportation Authority.
          </p>
        </div>
      </div>
    </footer>
  );
}
